import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Gate component that redirects authenticated users without a subscription
 * to the plan selection page. Used to enforce plan selection after registration.
 */
const RequirePlan = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) return children;

  const sub = user?.subscription;
  const hasPlan = sub && sub.plan && sub.plan !== 'none' && sub.status;

  // If user has no plan at all, redirect to trial plan selection
  if (!hasPlan) {
    return <Navigate to="/pricing?trial=true" replace />;
  }

  return children;
};

export default RequirePlan;
